import React from 'react';
import { CheckCircle } from 'lucide-react'; // Optional icon library
import { useNavigate } from 'react-router-dom';
import GoToTop from '../../helpers/GoToTop.js'


const Thankyou = ({ set }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/'); // Redirect to homepage
  };

  const handleCanshe = () => {
    navigate('/annadaanseva'); // Redirect to homepage
  };



  return (
    <>
      <div className="min-h-screen d-flex justify-content-center align-items-center bg-light">
        <div className="text-center p-4 bg-white mt-5 mb-5 rounded-4" style={{ maxWidth: '450px', width: '100%' }}>
          <CheckCircle size={64} style={{ color: '#9F1D21' }} />
          <h2 className="fw-bold mb-2" style={{ color: '#9F1D21' }}>Thank You!</h2>
          <p className="text-muted mb-4">
            Thank you for registering for the Annadaan Seva – your willingness to serve and share is truly appreciated. Our volunteers will reach out to you with the confirmation details.
          </p>
          <button
            className="btn px-4 py-2 rounded-pill text-white"
            style={{ backgroundColor: '#9F1D21', borderColor: '#9F1D21' }}
            onClick={handleGoHome}
          >
            Go Home
          </button>



          <p className="mt-3">
            If you want to cancel or reschedule the request, please{' '}
            <a href="#" onClick={(e) => { e.preventDefault(); handleCanshe(); }}>
              click here
            </a>.
          </p>
        </div>
      </div>
      <GoToTop set={set} />
    </>
  );
};

export default Thankyou;
